<div class="search-filter"
     [@showOpacity]="'show'"
     *ngIf="searchCtrl.valueChanges | async"
     (click)="onInputSearchClear()"></div>
<div class="search-input-container">
  <div class="search-input">
    <mat-icon [@inputSearchIcon]="inputFocus">search</mat-icon>
    <input [formControl]="searchCtrl"
           (focusin)="onInputFocusIn()"
           (focusout)="onInputFocusOut()"
           [placeholder]="'folder_selector.search' | translate"
           type="text">
    <div class="icon-clear"
         *ngIf="searchCtrl.valueChanges | async"
         (click)="onInputSearchClear()">
      <mat-icon>close</mat-icon>
    </div>
  </div>
  <div class="search-results"
       *ngIf="searchCtrl.valueChanges | async">
    <ng-content></ng-content>
  </div>
</div>
